/**
 * Download filenames for execution-templates bucket files.
 * Combines `workpill_execution_templates.name` with the storage object stem
 * (typically an ISO-like timestamp) so multiple versions stay distinct.
 */

export function sanitizeExecutionTemplateNameForFile(name: string): string {
  const trimmed = name.trim() || 'template';
  const sanitized = trimmed
    .replace(/[/\\]/g, '_')
    .replace(/[^a-zA-Z0-9._-]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  return sanitized || 'template';
}

/**
 * @param executionTemplateName — `workpill_execution_templates.name`
 * @param storageFileName — object name in Storage, e.g. `2026-03-13T17-30-45-123Z.docx`
 */
export function buildExecutionTemplateDownloadFilename(
  executionTemplateName: string,
  storageFileName: string
): string {
  const raw = storageFileName.trim().replace(/[/\\]/g, '');
  const lastDot = raw.lastIndexOf('.');
  const stem = lastDot > 0 ? raw.slice(0, lastDot) : raw;
  const ext = lastDot > 0 ? raw.slice(lastDot) : '';
  const base = sanitizeExecutionTemplateNameForFile(executionTemplateName);
  const safeStem = stem
    .replace(/[/\\]/g, '_')
    .replace(/[^a-zA-Z0-9._-]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '') || 'file';
  const lowerExt = ext ? ext.toLowerCase() : '';
  return `${base}_${safeStem}${lowerExt}`;
}
